import handleContactExpert from "../handleContactExpert";
import useActiveExperts from "./useActiveExperts";
import useContactAgentMutation from "./useContactAgentMutation";
import useFeatureState from "./useFeatureState";

const useContactExpert = () => {
  const { listing } = useActiveExperts();
  const {
    contactFormType,
    expertsApiUuid,
    modelVersion,
    segmentName
  } = useFeatureState();
  const [contactExpert] = useContactAgentMutation();

  return handleContactExpert({
    contactExpert,
    contactFormType,
    expertsApiUuid,
    listing,
    modelVersion,
    segmentName
  });
};

export default useContactExpert;
